import React from 'react';

import './style.scss';

export const BusinessLocalMap = ({ handleClick, regionsCount, selectedRegion, scaleW, svgWidth, length, signPosition }) => {
  return (
    <>
      <div className="business-map">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* 인천 */}
          <g className={'local ' + (selectedRegion === '인천' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('인천', e)}
              onKeyUp={e => handleClick('인천', e)}
              x="29.57"
              y="165.75"
              width="46"
              height="43"
              viewBox="0 0 46 43"
              fill="none"
            >
              <path
                d="M10.2708 32.6835L8.31259 37.8783L17.6766 42.7446L38.281 28.1845L36.9439 32.7743L37.716 33.3404L45.3375 25.6088L41.9645 18.0327L44.1945 14.934L37.289 11.3988L28.2527 0.75H17.7241L14.4978 2.93681L12.9925 6.83503L13.2211 12.1465L13.8767 12.1076C17.7241 11.8829 27.9853 12.194 29.2189 16.2392C30.5905 20.7381 24.1551 25.6347 23.0208 26.4515L13.799 26.149L12.6345 20.4832L0.570312 20.9413L10.2837 32.6835H10.2708Z"
                fill="currentColor"
              />
            </svg>
          </g>
          {/* 경기 */}
          <g className={'local ' + (selectedRegion === '경기' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('경기', e)}
              onKeyUp={e => handleClick('경기', e)}
              x="17.37"
              y="69.54"
              width="205"
              height="220"
              viewBox="0 0 205 220"
              fill="none"
            >
              <path
                d="M13.4469 85.3934L10.8805 89.7843L19.2957 99.5645L24.6743 98.605L29.3153 95.4588H40.8403L47.6898 103.532L51.9081 101.323L52.4559 95.6576L56.0532 94.1493L61.889 97.9957L64.671 97.2437V89.5942L69.5234 86.7461L74.13 86.2275L78.1715 77.0395L85.4738 79.6844L88.5017 77.208H95.4072L97.2188 98.9292L106.432 97.8444L107.674 105.641L105.293 107.668L106.609 113.252L90.6195 127.569L81.2943 123.248L71.253 124.976L64.7961 119.769L58.4643 122.306L50.7651 130.119L58.5591 135.811L60.5044 139.735L65.965 142.579L61.889 147.899L69.3897 154.118L50.5624 151.797L46.1844 167.477L59.7237 175.264L66.4783 183.67L71.9561 178.342L74.7166 182.534L72.8317 183.835L70.2653 194.544L80.4144 204.324L92.9616 213.49L105.483 212.505L110.68 214.082L120.76 210.768H120.838C121.278 210.725 131.647 209.921 134.817 213.244C136.159 214.649 137.69 217.026 138.997 219.26L151.652 211.684V206.1L163.233 198.766L176.328 193.221L194.853 175.2L196.48 152.809L204.036 137.76L202.613 131.576L200.478 123.451L204.377 119.721L200.284 112.711H196.523L185.589 105.866C182.595 105.429 178.032 104.802 177.376 104.802C176.013 104.802 169.423 99.9491 168.819 99.2663C168.525 98.9335 167.753 98.0605 172.42 92.5676L166.433 79.7017L178.347 58.8708C168.482 52.2758 168.357 51.6534 168.297 51.3509C168.215 51.0743 167.279 49.1425 166.377 47.2755C163.556 41.4411 162.646 39.4531 162.539 38.6493C161.667 37.7071 156.802 33.8391 153.373 31.2029L138.354 26.0038L125.932 13.4188L113.924 7.13499L99.6256 7.73139L92.3966 0.539978L68.1173 8.8464L57.5542 13.5917L58.4384 17.84L50.6185 21.0338L47.1463 29.7119L39.611 36.7563L33.8572 33.2255L31.5625 37.4954L32.973 42.2709L28.306 65.9282L31.1183 68.8627L20.0203 75.328L8.45648 71.1792L0.369141 83.9543L5.91166 86.919L13.4512 85.3891L13.4469 85.3934Z"
                fill="currentColor"
              />
              <text className="local-name" x="64%" y="65%">
                경기
              </text>
            </svg>
          </g>
          {/* 강원 */}
          <g className={'local ' + (selectedRegion === '강원' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('강원', e)}
              onKeyUp={e => handleClick('강원', e)}
              x="110.39"
              y="0"
              width="307"
              height="266"
              viewBox="0 0 307 266"
              fill="none"
            >
              <path
                d="M7.13654 75.419L21.215 74.8313L33.7105 81.3701L46.0636 93.8859L60.996 99.0548L61.078 99.1196C70.9036 106.67 70.8863 107.154 70.8734 107.543V107.698C71.1494 108.697 73.2586 113.062 74.5439 115.719C75.9242 118.572 76.3986 119.574 76.5324 119.972C77.1276 120.664 82.0533 124.121 86.5736 127.133L87.0782 127.47L74.8933 148.772L80.9491 161.785L80.6774 162.101C78.9133 164.153 77.0284 166.738 76.886 167.507C77.9471 168.536 83.5673 172.369 84.4127 172.507C85.3616 172.507 92.142 173.493 92.9097 173.605L93.0435 173.622L103.891 180.416H108.023L113.005 188.956L108.921 192.867L110.866 200.275L112.397 206.935L104.75 222.169L103.154 244.167L109.46 248.242L132.234 235.813L136.4 239.266L148.249 241.902L158.359 235.877L173.485 240.977L176.375 248.013L191.127 257.067L204.899 255.965L211.36 265.062C212.921 265.356 221.634 266.873 226.974 265.036C232.758 263.044 236.791 255.982 236.83 255.909L236.955 255.688L241.781 254.115L261.924 260.019L272.246 257.776L277.879 256.618L284.53 262.534L288.787 260.715L306.722 245.999C303.94 238.116 300.329 229.658 300.084 229.079L300.058 229.023L268.213 182.002L262.256 163.557L262.218 163.44L225.348 117.893L184.428 32.7978L174.033 6.07207L164.747 0L160.667 7.87857L139.208 45.197L101.441 55.6513L77.6538 48.4556L49.5012 53.0583L19.1834 49.0088L0.390625 68.7246L7.11498 75.419H7.13654Z"
                fill="currentColor"
              />
              <text className="local-name" x="54%" y="60%">
                강원
              </text>
            </svg>
          </g>
          {/* 충남 */}
          <g className={'local ' + (selectedRegion === '충남' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('충남', e)}
              onKeyUp={e => handleClick('충남', e)}
              x="5.51"
              y="261.46"
              width="197"
              height="174"
              viewBox="0 0 197 174"
              fill="none"
            >
              <path
                d="M20.7906 59.0285L25.2678 69.6903L27.6616 93.0105L37.4484 112.614L37.8366 112.627C40.5971 112.709 44.6731 112.834 45.6996 112.886L45.8592 113.068L46.3121 112.83C46.614 112.672 46.5896 111.872 46.2388 110.432C45.98 109.368 45.6134 107.851 45.1691 106.028C44.2806 102.384 43.0988 97.531 41.9126 92.6734C39.9587 84.6695 38.0005 76.6656 37.3751 74.0984L44.3798 74.4528L48.6542 70.8355L50.7634 96.7704L54.8437 105.172L53.8387 133.393L53.9034 152.612L67.1753 167.889L79.1704 166.748L90.2986 160.231L95.2329 158.278L99.4039 149.384L104.92 144.582L111.52 145.939L123.593 144.197V144.945C123.593 144.988 123.623 149.427 126.232 154.531C128.242 158.455 140.354 155.801 145.055 154.388L152.138 147.37L164.465 159.514L160.445 164.873L177.21 173.391L183.322 166.342L189.012 168.434L195.253 167.319L195.663 162.193L196.995 155.482L192.397 147.374L190.573 140.325L178.181 130.394L169.843 136.12L163.486 134.262L159.88 137.378L156.183 134.106L149.727 130.411L147.19 118.409L148.898 108.534L153.156 104.256L154.812 102.881L151.555 91.0225L140.362 78.606L138.275 71.5702L144.102 65.2821L149.261 66.7083L158.478 55.2426L164.944 52.6496L164.133 48.5482L152.875 33.4739L152.849 33.422C152.81 33.3399 148.773 25.1545 145.883 22.125C143.623 19.7566 135.907 19.8085 133.021 20.0332L122.7 23.4258L117.347 21.8008L103.928 22.8553L95.3408 27.5099L82.7892 11.7743L52.6224 0.459961L22.8955 14.2723L15.4465 27.9637L3.54198 41.4519L0.509766 54.7975L12.6127 63.4972L20.7906 59.0112V59.0285Z"
                fill="currentColor"
              />
              <text className="local-name" x="42%" y="78%">
                충남
              </text>
            </svg>
          </g>
          {/* 세종 */}
          <g className={'local ' + (selectedRegion === '세종' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('세종', e)}
              onKeyUp={e => handleClick('세종', e)}
              x="144.73"
              y="327.76"
              width="27"
              height="36"
              viewBox="0 0 27 36"
              fill="none"
            >
              <path
                d="M0.730469 5.92882L2.5291 11.975L13.7306 24.4L16.9138 35.991L26.6056 27.9698L20.153 10.7778L10.1937 2.04789L5.52249 0.76001L0.730469 5.92882Z"
                fill="currentColor"
              />
            </svg>
          </g>
          {/* 대전 */}
          <g className={'local ' + (selectedRegion === '대전' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('대전', e)}
              onKeyUp={e => handleClick('대전', e)}
              x="153.51"
              y="356.25"
              width="34"
              height="41"
              viewBox="0 0 34 41"
              fill="none"
            >
              <path
                d="M2.10135 14.1747L0.509766 23.4017L2.87343 34.5907L8.98961 38.1043L11.8924 40.6714L15.1748 37.832L21.6188 39.7163L29.4258 34.353L25.5223 24.1105L33.036 14.9699L29.1497 10.5747L24.5302 4.51558L19.2594 3.39193L18.0776 0.25L6.00485 10.2506L2.10135 14.1747Z"
                fill="currentColor"
              />
            </svg>
          </g>
          {/* 충북 */}
          <g className={'local ' + (selectedRegion === '충북' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('충북', e)}
              onKeyUp={e => handleClick('충북', e)}
              x="155.4"
              y="237.3"
              width="166"
              height="187"
              viewBox="0 0 166 187"
              fill="none"
            >
              <path
                d="M72.1771 129.08L74.7435 124.702L70.4216 112.51L74.2 108.672L70.4561 97.7254L74.9203 90.56L83.37 91.6663L88.6882 80.0062H100.08L102.085 65.6364L107.792 61.9456L123.358 63.1989L139.464 66.1334L145.99 57.6627L141.806 49.1748L149.811 39.991L165.097 28.5081L159.279 20.3141L145.821 21.3945L130.35 11.8996L127.525 5.01934L113.52 0.299988L103.478 6.28129L90.8233 3.46352L87.0923 0.369124L64.4133 12.7467L57.5682 8.3255L39.06 26.3299L25.7925 31.9482L14.9533 38.8242V44.4295L1.64693 52.3902C2.88051 54.5856 3.80786 56.4483 3.98901 56.8157L15.3501 72.0282L16.4284 77.4737L9.28136 80.339L0.400391 91.3854L10.2475 100.016L18.2227 121.27L23.2735 122.347L28.1691 128.769L32.7411 133.942L25.0032 143.355L28.7557 153.204L41.7213 163.593L43.6148 170.893L48.368 179.273L47.5355 183.473C50.8611 184.174 66.6217 187.398 72.1124 186.922C78.5564 186.365 82.9689 185.781 85.4576 182.912C87.9248 180.072 94.1315 163.913 94.895 161.908L92.6435 154.224L86.9327 155.741L72.85 147.261L71.5776 139.353L74.0965 137.049L72.1858 129.08H72.1771Z"
                fill="currentColor"
              />
              <text className="local-name" x="38%" y="32%">
                충북
              </text>
            </svg>
          </g>
          {/* 경북 */}
          <g className={'local ' + (selectedRegion === '경북' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('경북', e)}
              onKeyUp={e => handleClick('경북', e)}
              x="226.88"
              y="247.31"
              width="218"
              height="252"
              viewBox="0 0 218 252"
              fill="none"
            >
              <path
                d="M215.668 166.849L199.523 179.192L192.247 175.903L191.94 171.737L197.772 164.943L192.967 147.535L191.341 129.652L198.846 100.743L198.88 100.609L194.52 75.3358L200.744 66.6015L200.77 66.4589C200.86 65.9705 202.926 54.3882 197.008 46.6868C195.141 44.2537 194.235 42.875 193.799 42.1058L194.028 42.2397L194.015 41.0902C194.015 40.8481 193.717 17.0007 193.942 11.4299C194.024 9.3425 192.799 5.0164 191.181 0.309998L173.471 14.8398L168.291 17.0525L161.51 11.0237L156.52 12.0522L145.884 14.3644L125.81 8.48246L121.837 9.77466C121.074 11.0582 117.123 17.2988 111.403 19.2696C109.286 19.9999 106.724 20.242 104.256 20.242C100.116 20.242 96.2338 19.5591 95.1469 19.3474L79.6407 30.9945L72.3427 39.3831L76.5007 47.8191L69 57.5561L52.1524 54.4833L37.1207 53.2775L32.2813 56.4065L30.2023 71.3079H18.5177L13.1477 83.0804L4.57731 81.9567L0.880859 87.8905L4.68515 99.0147L0.915346 102.844L5.16391 114.837L2.55869 119.288L4.52553 127.491L1.95917 129.838L3.02453 136.463L16.1239 144.35L22.5247 142.652L25.2507 151.965L25.1731 152.168C24.8884 152.92 18.1899 170.579 15.4251 173.768C12.9838 176.582 9.15365 177.424 3.75347 177.978L7.74754 190.338L3.64132 197.192L4.55573 201.587L21.4291 209.972L34.7959 213.563L42.6719 224.501L47.7357 230.228L43.5345 237.385L47.9988 241.447H57.8632L62.5905 239.995L66.9641 243.703H72.636L79.9772 239.424L82.88 235.306L76.8889 227.963L78.7263 225.331L83.1603 223.602L83.6736 221.861L80.6242 216.727L83.8936 211.216L87.1932 209.099L87.6893 206.605L78.4115 204.937L79.3 198.726L91.0838 196.116L95.7809 181.651L111.283 175.605L122.683 183.851L120.509 192.36L122.73 196.587L117.796 202.141L116.057 214.224L109.993 221.792L98.261 225.331L95.7205 229.091L97.8426 234.614L87.5383 240.531L88.1163 244.062L95.177 251.841L104.507 248.236L116.118 251.932L124.662 249.693L135.437 241.667L144.853 244.304C147.143 243.863 152.918 242.493 154.441 240.963C156.434 238.966 161.648 232.324 161.7 232.255L161.791 232.138L161.925 232.073L174.886 225.737L184.552 238.089L192.109 236.071L194.895 232.695L203.478 237.047L204.427 232.583L211.484 194.02L217.462 176.392L215.685 166.858L215.668 166.849Z"
                fill="currentColor"
              />
              <text className="local-name" x="48%" y="50%">
                경북
              </text>
            </svg>
          </g>
          {/* 전북 */}
          <g className={'local ' + (selectedRegion === '전북' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('전북', e)}
              onKeyUp={e => handleClick('전북', e)}
              x="42.51"
              y="406.69"
              width="191"
              height="136"
              viewBox="0 0 191 136"
              fill="none"
            >
              <path
                d="M186.437 19.1007C186.04 19.1396 185.634 19.1742 185.22 19.2087C184.815 19.2433 184.358 19.2606 183.862 19.2606C177.318 19.2606 163.469 16.4169 160.281 15.7427L159.949 17.4195L159.47 23.4268L151.9 24.7752L146.72 22.8693L140.531 30.0045L121.488 20.3281L125.758 14.6406L115.147 4.19062L108.746 10.5393L108.595 10.5868C106.801 11.1314 90.9758 15.7643 88.0902 10.1244C85.9422 5.92796 85.4505 2.22423 85.3384 0.690002L74.4862 2.25448L68.2881 0.979553L63.4573 5.18029L59.1872 14.2906L53.8215 16.4125L42.5769 23.0076L30.6119 24.1442L27.3468 33.7601L27.6789 39.7846L45.4063 38.8511L35.0459 53.4241L27.8169 57.9447L22.4211 68.4379L3.56786 79.5665V86.8962H26.1261L24.2844 93.1109L3.69294 100.259L0.509766 110.549C3.57217 110.839 7.43253 111.634 7.75171 113.812C8.10971 116.271 16.3868 126.471 17.9482 127.931C18.4184 127.888 19.1473 127.992 20.2601 128.173C21.4592 128.368 23.1198 128.679 25.1902 129.094C28.0671 129.673 30.9613 130.304 31.949 130.52L36.4132 125.935L44.6731 109.499L49.7584 110.497L59.3468 105.411L65.4586 115.238L71.1521 119.677L75.6594 117.084L76.5566 111.042L82.2285 112.593V121.038L84.6181 128.757L89.3195 135.447L100.797 131.674L121.065 131.129L134.005 126.03L145.53 129.535L154.096 132.875V124.612L160.85 115.169L152.25 97.3634L154.139 84.9341L157.443 81.9088L157.585 62.6683L173.458 52.3999L178.634 48.7091L187.58 44.2447L186.268 37.9392L190.331 31.1541L186.432 19.0834L186.437 19.1007Z"
                fill="currentColor"
              />
              <text className="local-name" x="38%" y="65%">
                전북
              </text>
            </svg>
          </g>
          {/* 대구 */}
          <g className={'local ' + (selectedRegion === '대구' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('대구', e)}
              onKeyUp={e => handleClick('대구', e)}
              x="304.5"
              y="424.06"
              width="44"
              height="63"
              viewBox="0 0 44 63"
              fill="none"
            >
              <path
                d="M1.55243 49.3843L0.5 50.8882L6.4911 58.2352L4.65798 60.8413L8.75988 62.4576L18.2188 57.0252L16.2563 51.9082L19.4308 47.2061L31.2233 43.6536L36.8132 36.6739L38.5601 24.5601L43.1537 19.3869L41.1221 15.5146L43.2011 7.37676L33.0866 0.0599976L18.8141 5.63075L14.0781 20.2124L2.44528 22.7882L1.863 26.8722L11.2098 28.5534L10.3428 32.8795L6.84048 35.1311L4.11882 39.7122L7.06046 44.6735L6.21073 47.5691L1.55243 49.3843Z"
                fill="currentColor"
              />
            </svg>
          </g>
          {/* 전남 */}
          <g className={'local ' + (selectedRegion === '전남' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('전남', e)}
              onKeyUp={e => handleClick('전남', e)}
              x="1"
              y="513.8"
              width="224"
              height="189"
              viewBox="0 0 224 189"
              fill="none"
            >
              <path
                d="M221.175 104.457L217.539 74.2439L219.566 68.1502L208.688 64.0834L196.097 30.2267V27.2793L187.083 23.7657L176.058 20.4163L163.325 25.4339L143.019 25.9784L130.808 29.9934L125.438 22.3481L122.928 14.2448V6.59102L119.615 5.68778L118.839 10.9041L113.037 14.2405L106.477 9.12789L106.416 9.0285L100.883 0.130005L91.9541 4.86664L87.382 3.972L79.4715 19.7076L74.3647 24.9498L74.0153 24.8721C68.3606 23.6188 62.0029 22.3438 60.3811 22.2358L60.3596 22.3222L59.8032 22.3136C59.0742 22.279 56.1887 18.7179 53.8983 15.7359C51.5562 12.689 48.7095 8.70002 48.4636 7.01021C48.2911 5.83037 45.1942 5.12592 42.1059 4.84068L33.1645 33.7533L26.7076 37.967L29.3603 48.3954L41.6703 57.9379L26.9362 65.1941L15.092 88.3285L18.038 108.654H27.5099L19.1767 122.95L21.6784 136.823L0 158.877V171.462L11.2446 179.747L33.5182 171.985L40.9888 159.616L39.8113 144.576L45.3408 148.051L52.0091 179.319L59.8075 188.477L72.0528 183.805L68.4469 175.468L84.0393 184.146L109.69 175.533L113.978 166.535L116 159.067L107.081 159.651L118.429 147.195L119.49 135.535L137.498 123.646L154.35 113.9C155.596 115.43 157.908 118.624 157.83 120.253C157.761 121.714 153.142 125.431 149.89 127.6L136.428 136.378L128.078 154.888L135.518 164.378L135.634 164.443C136.954 165.174 143.648 168.756 146.12 167.62C146.642 167.378 146.982 166.954 147.099 166.388C147.737 163.346 149.338 156.53 149.35 156.461L149.488 155.865L140.413 153.177L145.149 149.11L150.442 150.242L156.994 162.455L164.835 153.954L176.468 146.218L173.828 142.545L179.565 140.362L193.376 144.179L193.691 135.972L181.346 133.469L169.48 116.537L174.367 106.225L169.743 102.94L172.521 101.536L177.503 102.845L182.744 95.7187H184.219L182.705 105.391L191.918 114.873L188.579 128.322L198.966 139.446L215.438 144.192L215.451 136.711L221.809 136.395L223.021 122.989L217.59 107.997L221.17 104.444L221.175 104.457ZM129.898 74.3562L124.881 78.5095L120.775 75.7651L112.054 82.2478H105.675L98.8984 74.4859L89.2842 75.6657L86.4116 70.7951L89.0599 58.5472L91.8247 57.1599L93.4249 52.5184L99.9854 51.6627L100.667 55.0898L106.912 54.8392L111.131 51.7664L116.634 50.2581L125.166 57.6353L132.986 60.3148L129.893 74.3519L129.898 74.3562Z"
                fill="currentColor"
              />
              <text className="local-name" x="23%" y="65%">
                전남
              </text>
            </svg>
          </g>
          {/* 광주 */}
          <g className={'local ' + (selectedRegion === '광주' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('광주', e)}
              onKeyUp={e => handleClick('광주', e)}
              x="87.9"
              y="564.7"
              width="45"
              height="30"
              viewBox="0 0 45 30"
              fill="none"
            >
              <path
                d="M29.3169 0.689941L24.7017 1.95191L20.3626 5.11542L12.6203 5.4309L11.9604 2.10317L7.39264 2.69957L5.87869 7.08184L3.19585 8.4259L0.789062 19.5717L2.97156 23.2755L12.4262 22.1172L19.267 29.9483H24.6284L33.738 23.1761L37.801 25.8945L41.7347 22.6402L44.4779 10.1676L37.5163 7.77764L29.3169 0.689941Z"
                fill="currentColor"
              />
            </svg>
          </g>
          {/* 경남 */}
          <g className={'local ' + (selectedRegion === '경남' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('경남', e)}
              onKeyUp={e => handleClick('경남', e)}
              x="195.88"
              y="450.21"
              width="197"
              height="187"
              viewBox="0 0 197 187"
              fill="none"
            >
              <path
                d="M149.038 120.264L162.315 113.937L162.262 113.884L164.89 111.479L163.96 109.395L165.381 106.071L170.487 104.372L182.942 90.9268L196.209 74.5747L176.319 46.8723L175.572 42.4903L167.015 40.0963L156.547 47.8876L147.393 50.2816L135.857 46.6158L126.125 50.3778L118.21 41.6567L117.559 37.6595L113.211 35.9495L112.186 37.4137L104.302 42.0094H97.8078L93.6099 38.4504L89.3692 39.7543H78.8049L73.1969 34.6456L77.4589 27.3887L72.9512 22.2907L65.3244 11.6992L52.2178 8.17228L36.195 0.209961L36.3552 0.990172L26.56 5.87444L21.4861 9.49754L6.16836 19.405L6.02951 38.5145L2.64337 41.614L0.880859 53.1887L9.63996 71.3256L2.68609 81.0514V93.0002L14.9916 126.089L26.4852 130.386L24.1566 137.386L28.2477 171.405L33.3109 184.69L52.3459 181.718L55.6893 175.028L59.1075 158.516L67.151 154.176L70.4089 156.549L72.5132 163.047L82.1589 165.751L89.1128 161.059L82.458 153.482L87.9378 152.488L94.1867 158.441L99.4315 178.149L99.4956 178.384L112.549 186.966L119.246 178.491L114.792 167.205L123.604 161.968L123.861 176.61L134.286 178.726L136.23 171.907C138.741 171.437 143.612 170.272 143.612 168.188C143.612 166.275 141.657 152.883 141.571 152.317L137.95 139.096L138.313 134.041L131.285 134.629L124.374 146.631L120.229 142.452L116.245 147.603L110.38 146.31L111.085 140.101L116.277 134.639L113.82 125.117L117.356 124.037L120.165 129.873L128.443 130.92L132.834 124.347L129.063 119.26L129.501 113.339L149.017 120.296L149.038 120.264Z"
                fill="currentColor"
              />
              <text className="local-name" x="35%" y="52%">
                경남
              </text>
            </svg>
          </g>
          {/* 울산 */}
          <g className={'local ' + (selectedRegion === '울산' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('울산', e)}
              onKeyUp={e => handleClick('울산', e)}
              x="371.57"
              y="474.36"
              width="59"
              height="60"
              viewBox="0 0 59 60"
              fill="none"
            >
              <path
                tabIndex="0"
                d="M50.2287 7.31374L47.8392 10.2136L39.0574 12.5603L29.5122 0.359985L17.6249 6.16846C16.8916 7.10196 12.2765 12.9493 10.3571 14.8725C8.50669 16.7265 2.61048 18.0619 0.570312 18.4768L1.23023 22.3448L21.2135 50.1899H29.0852L29.275 50.3714C29.4259 50.5184 32.9541 53.9282 33.6054 54.5722C34.3948 55.0346 41.5591 57.4073 46.8601 59.11L48.87 54.7018V35.3187L55.7842 35.2063V22.7597L58.2039 11.3546L50.2373 7.31374H50.2287Z"
                fill="currentColor"
              />
            </svg>
          </g>
          {/* 부산 */}
          <g className={'local ' + (selectedRegion === '부산' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('부산', e)}
              onKeyUp={e => handleClick('부산', e)}
              x="359.28"
              y="525.48"
              width="59"
              height="58"
              viewBox="0 0 59 58"
              fill="none"
            >
              <path
                tabIndex="0"
                d="M58.6448 9.30796H58.6342C52.3426 7.27731 45.5382 5.02223 45.0469 4.51991C44.5769 4.04966 41.6607 1.22812 40.8809 0.47998H33.5212L20.1475 16.9603L7.38271 30.7474L2.56519 32.3505L1.69997 34.3705L2.81089 36.8714L0.279297 39.1907L8.29067 57.1352L17.8723 54.3244L26.6848 50.0386L39.7273 55.842L41.3082 49.6004L32.6987 41.7557L46.2325 36.5508L58.6448 9.30796Z"
                fill="currentColor"
              />
            </svg>
          </g>
          {/* 제주 */}
          <g className={'local ' + (selectedRegion === '제주' ? 'active' : '')}>
            <svg
              tabIndex="0"
              role="button"
              onClick={e => handleClick('제주', e)}
              onKeyUp={e => handleClick('제주', e)}
              x="21.05"
              y="804.32"
              width="107"
              height="61"
              viewBox="0 0 107 61"
              fill="none"
            >
              <path
                tabIndex="0"
                d="M103.954 0.863202C102.246 -0.109194 100.495 0.262475 100.063 1.67137C99.6235 3.08026 100.659 4.99915 102.371 5.96723C104.083 6.94395 105.826 6.57656 106.262 5.17631C106.706 3.76742 105.671 1.83992 103.954 0.858876V0.863202Z"
                fill="currentColor"
              />
              <path
                d="M82.8435 4.17338L69.2094 5.53042C69.2094 5.53042 24.2783 13.0244 8.63414 29.3563C8.63414 29.3563 2.06507 36.163 0.0507812 44.3441L11.662 60.6718C11.662 60.6718 17.2046 62.716 21.2547 56.5877L37.9125 57.9448C37.9125 57.9448 53.0606 55.222 59.1077 56.5877L65.1635 48.4153L73.7555 49.7896L88.9036 44.3398C88.9036 44.3398 93.4412 32.0746 99.5013 28.6734V19.8181L94.4591 11.663C94.4591 11.663 84.8578 3.49054 82.8478 4.16905L82.8435 4.17338Z"
                fill="currentColor"
              />
              <text className="local-name" x="51%" y="80%">
                제주
              </text>
            </svg>
          </g>
          {/* --- 그 외 --- */}
          <g>
            {/* 서울 */}
            <svg x="65.56" y="147.5" width="59" height="49" viewBox="0 0 59 49" fill="none">
              <path
                d="M57.3617 21.2747L48.0537 22.3724L46.2292 0.5H40.9757L37.7407 3.14924L30.8827 0.668555L27.0309 9.42876L21.9542 10.0036L17.9774 12.3373V20.2375L13.6771 21.3957L7.93188 17.6099L5.68468 18.552L5.14121 24.1444L0.560547 26.5386L2.10469 28.3624L10.1273 32.4638L7.45311 36.1848L10.4508 42.9138L17.0328 40.2775L23.6235 45.5933L33.4836 43.8948L42.4033 48.0307L57.1848 34.7932L55.865 29.1879L58.2933 27.1221L57.3617 21.2747Z"
                fill="#31C1BB"
              />
            </svg>
          </g>
          <g>
            {/* 울릉도 & 독도 */}
            <svg x="464.65" y="174" width="48" height="26" viewBox="0 0 48 26" fill="none">
              <path
                d="M13.2239 21.3808L0.646484 12.586L7.68141 3.99006L7.83668 3.92956L16.7953 0.307922L21.3242 5.27362L23.8 12.6811L20.0259 18.4031L13.2282 21.3808H13.2239Z"
                fill="#31C1BB"
              />
              <path d="M39.1617 25.0968L31.6523 20.6756L39.2436 15.537L44.3851 14.3572L47.9089 20.9306L39.1617 25.0968Z" fill="#31C1BB" />
            </svg>
          </g>
          {/* --- 푯말 영역 --- */}
          {/* 인천 */}
          <g className={'flag ' + (selectedRegion === '인천' ? 'active' : '')}>
            <svg x={`${35 - length * signPosition}`} y="135" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('인천', e)}
                onKeyUp={e => handleClick('인천', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('인천', e)}
                onKeyUp={e => handleClick('인천', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '인천')?.count}
              </text>
            </svg>
            <svg x="22" y="175" width="50" height="32" viewBox="0 0 50 32" fill="none">
              <text
                className="local-name"
                onClick={e => handleClick('인천', e)}
                onKeyUp={e => handleClick('인천', e)}
                x="60%"
                y="88%"
                // dominant-baseline="hanging"
              >
                인천
              </text>
            </svg>
          </g>
          {/* 경기 */}
          <g className={'flag ' + (selectedRegion === '경기' ? 'active' : '')}>
            <svg x={`${130 - length * signPosition}`} y="145" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('경기', e)}
                onKeyUp={e => handleClick('경기', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('경기', e)}
                onKeyUp={e => handleClick('경기', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '경기')?.count}
              </text>
            </svg>
          </g>
          {/* 강원 */}
          <g className={'flag ' + (selectedRegion === '강원' ? 'active' : '')}>
            <svg x={`${258 - length * signPosition}`} y="90" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('강원', e)}
                onKeyUp={e => handleClick('강원', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('강원', e)}
                onKeyUp={e => handleClick('강원', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '강원')?.count}
              </text>
            </svg>
          </g>
          {/* 충남 */}
          <g className={'flag ' + (selectedRegion === '충남' ? 'active' : '')}>
            <svg x={`${70 - length * signPosition}`} y="330" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('충남', e)}
                onKeyUp={e => handleClick('충남', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('충남', e)}
                onKeyUp={e => handleClick('충남', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '충남')?.count}
              </text>
            </svg>
          </g>
          {/* 세종 */}
          <g className={'flag ' + (selectedRegion === '세종' ? 'active' : '')}>
            <svg x={`${125 - length * signPosition}`} y="295" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('세종', e)}
                onKeyUp={e => handleClick('세종', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('세종', e)}
                onKeyUp={e => handleClick('세종', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '세종')?.count}
              </text>
            </svg>
            <svg x="116" y="340" width="50" height="32" viewBox="0 0 50 32" fill="none">
              <text className="local-name" x="52%" y="75%">
                세종
              </text>
            </svg>
          </g>
          {/* 충북 */}
          <g className={'flag ' + (selectedRegion === '충북' ? 'active' : '')}>
            <svg x={`${200 - length * signPosition}`} y="230" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('충북', e)}
                onKeyUp={e => handleClick('충북', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('충북', e)}
                onKeyUp={e => handleClick('충북', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '충북')?.count}
              </text>
            </svg>
          </g>
          {/* 대전 */}
          <g className={'flag ' + (selectedRegion === '대전' ? 'active' : '')}>
            <svg x={`${163 - length * signPosition}`} y="411" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('대전', e)}
                onKeyUp={e => handleClick('대전', e)}
                d="M32 8L51 8L51 40L1 40L0.999997 8L22 8L22.5146 8L22.8137 7.58124L27 1.72047L31.1863 7.58124L31.4854 8L32 8Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('대전', e)}
                onKeyUp={e => handleClick('대전', e)}
                x={`${svgWidth / 2}`}
                y="26"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '대전')?.count}
              </text>
            </svg>
            <svg x="155" y="373" width="50" height="32" viewBox="0 0 50 32" fill="none">
              <text className="local-name" x="53%" y="75%">
                대전
              </text>
            </svg>
          </g>
          {/* 전북 */}
          <g className={'flag ' + (selectedRegion === '전북' ? 'active' : '')}>
            <svg x={`${100 - length * 3}`} y="428" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('전북', e)}
                onKeyUp={e => handleClick('전북', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('전북', e)}
                onKeyUp={e => handleClick('전북', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '전북')?.count}
              </text>
            </svg>
          </g>
          {/* 전남 */}
          <g className={'flag ' + (selectedRegion === '전남' ? 'active' : '')}>
            <svg x={`${33 - length * signPosition}`} y="570" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('전남', e)}
                onKeyUp={e => handleClick('전남', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('전남', e)}
                onKeyUp={e => handleClick('전남', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '전남')?.count}
              </text>
            </svg>
          </g>
          {/* 광주 */}
          <g className={'flag ' + (selectedRegion === '광주' ? 'active' : '')}>
            <svg x={`${103 - length * signPosition}`} y="518" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('광주', e)}
                onKeyUp={e => handleClick('광주', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('광주', e)}
                onKeyUp={e => handleClick('광주', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '광주')?.count}
              </text>
            </svg>
            <svg x="95" y="566" width="50" height="32" viewBox="0 0 50 32" fill="none">
              <text className="local-name" x="53%" y="80%">
                광주
              </text>
            </svg>
          </g>
          {/* 경북 */}
          <g className={'flag ' + (selectedRegion === '경북' ? 'active' : '')}>
            <svg x={`${311 - length * signPosition}`} y="305" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('경북', e)}
                onKeyUp={e => handleClick('경북', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('경북', e)}
                onKeyUp={e => handleClick('경북', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '경북')?.count}
              </text>
            </svg>
          </g>
          {/* 대구 */}
          <g className={'flag ' + (selectedRegion === '대구' ? 'active' : '')}>
            <svg x={`${323 - length * signPosition}`} y="395" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('대구', e)}
                onKeyUp={e => handleClick('대구', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('대구', e)}
                onKeyUp={e => handleClick('대구', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '대구')?.count}
              </text>
            </svg>
            <svg x="314" y="441" width="50" height="32" viewBox="0 0 50 32" fill="none">
              <text className="local-name" onClick={e => handleClick('대구', e)} onKeyUp={e => handleClick('대구', e)} x="52%" y="78%">
                대구
              </text>
            </svg>
          </g>
          {/* 경남 */}
          <g className={'flag ' + (selectedRegion === '경남' ? 'active' : '')}>
            <svg x={`${247 - length * signPosition}`} y="480" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('경남', e)}
                onKeyUp={e => handleClick('경남', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('경남', e)}
                onKeyUp={e => handleClick('경남', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '경남')?.count}
              </text>
            </svg>
          </g>
          {/* 울산 */}
          <g className={'flag ' + (selectedRegion === '울산' ? 'active' : '')}>
            <svg x={`${392 - length * signPosition}`} y="460" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('울산', e)}
                onKeyUp={e => handleClick('울산', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('울산', e)}
                onKeyUp={e => handleClick('울산', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '울산')?.count}
              </text>
            </svg>
            <svg x="385" y="515" width="50" height="32" viewBox="0 0 50 32" fill="none">
              <text className="local-name" x="50%" y="50%">
                울산
              </text>
            </svg>
          </g>
          {/* 부산 */}
          <g className={'flag ' + (selectedRegion === '부산' ? 'active' : '')}>
            <svg x={`${375 - length * signPosition}`} y="590" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('부산', e)}
                onKeyUp={e => handleClick('부산', e)}
                d="M32 8L51 8L51 40L1 40L0.999997 8L22 8L22.5146 8L22.8137 7.58124L27 1.72047L31.1863 7.58124L31.4854 8L32 8Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('부산', e)}
                onKeyUp={e => handleClick('부산', e)}
                x={`${svgWidth / 2}`}
                y="26"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '부산')?.count}
              </text>
            </svg>
            <svg x="375" y="560" width="50" height="32" viewBox="0 0 50 32" fill="none">
              <text className="local-name" x="42%" y="50%">
                부산
              </text>
            </svg>
          </g>
          {/* 제주 */}
          <g className={'flag ' + (selectedRegion === '제주' ? 'active' : '')}>
            <svg x={`${58 - length * signPosition}`} y="783" width={`${svgWidth}`} height="41" viewBox={`0 0 ${svgWidth} 41`} fill="none">
              <path
                onClick={e => handleClick('제주', e)}
                onKeyUp={e => handleClick('제주', e)}
                d="M20 33H1V1H51V33H30H29.4854L29.1863 33.4188L25 39.2795L20.8137 33.4188L20.5146 33H20Z"
                transform={`scale(${scaleW}, 1)`}
              />
              <text
                className="number"
                onClick={e => handleClick('제주', e)}
                onKeyUp={e => handleClick('제주', e)}
                x={`${svgWidth / 2}`}
                y="19.5"
                dominantBaseline="middle"
              >
                {regionsCount.find(region => region.name === '제주')?.count}
              </text>
            </svg>
          </g>
        </svg>
      </div>
    </>
  );
};
